import { api } from "../api";

/**
 * findAllAcessesByCustomer - Function that finds on database all accesses by customer   
 * /users/{customerType}/{customerId}/{id}/{status}  
 * method GET
 * @async-function
 */
const findAllAcessesByCustomer = async (token: string, customerId: number, id: number, customerType: string, status: string, page: number, size: number, search: string = "") => {    
    const response = await api.get(
        `/users/${customerType}/${customerId}/${id}/${status}?page=${page}&size=${size}&search=${search}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default findAllAcessesByCustomer;